import script from "./CalendarIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarIcon.vue?vue&type=script&setup=true&lang=js"

export default script